/* ShopAMify custom behaviour */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero slider */
  if (!customElements.get('sa-hero-slider')) {
    customElements.define('sa-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sa-hero__track');
        this.slides = [...this.querySelectorAll('.sa-hero__slide')];
        this.dots = [...this.querySelectorAll('.sa-hero__dot')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i, true)));
        this.querySelectorAll('.sa-hero__arrow').forEach((b) =>
          b.addEventListener('click', () => this.go(this.index + Number(b.dataset.dir), true))
        );
        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this._t);
          this._t = window.setTimeout(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            this.setActive(i);
          }, 80);
        }, { passive: true });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
        });
        if (this.dataset.autoplay === 'true' && !reduce) {
          this.delay = (Number(this.dataset.speed) || 6) * 1000;
          this.play();
          ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => this.stop(), { passive: true }));
          ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => this.play()));
          document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.play()));
        }
      }
      setActive(i) {
        this.index = i;
        this.dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
      }
      go(i, user) {
        const n = this.slides.length;
        const target = ((i % n) + n) % n;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        this.setActive(target);
        if (user) { this.stop(); this.play(); }
      }
      play() {
        if (!this.delay) return;
        this.stop();
        this.timer = window.setInterval(() => this.go(this.index + 1), this.delay);
      }
      stop() { window.clearInterval(this.timer); }
    });
  }

  /* Delivery estimate: business days, skips weekends and US carrier holidays */
  const fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const nth = (y, m, wd, n) => { const d = new Date(y, m, 1); let c = 0; while (true) { if (d.getDay() === wd && ++c === n) return d.getDate(); d.setDate(d.getDate() + 1); } };
  const last = (y, m, wd) => { const d = new Date(y, m + 1, 0); while (d.getDay() !== wd) d.setDate(d.getDate() - 1); return d.getDate(); };
  const holidayCache = {};
  const holidays = (y) => {
    if (holidayCache[y]) return holidayCache[y];
    const list = [[0, 1], [0, nth(y, 0, 1, 3)], [1, nth(y, 1, 1, 3)], [4, last(y, 4, 1)], [5, 19], [6, 4], [8, nth(y, 8, 1, 1)], [9, nth(y, 9, 1, 2)], [10, 11], [10, nth(y, 10, 4, 4)], [11, 25]];
    return (holidayCache[y] = new Set(list.map(([m, d]) => m * 100 + d)));
  };
  const isWorkday = (d) => { const w = d.getDay(); return w !== 0 && w !== 6 && !holidays(d.getFullYear()).has(d.getMonth() * 100 + d.getDate()); };
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); if (isWorkday(d)) added++; }
    return d;
  };
  document.querySelectorAll('[data-sa-delivery]').forEach((el) => {
    const min = Number(el.dataset.min) || 10;
    const max = Number(el.dataset.max) || 15;
    const now = new Date();
    const cutoff = Number(el.dataset.cutoff) || 14;
    const start = (now.getHours() >= cutoff || !isWorkday(now)) ? addBusinessDays(now, 1) : now;
    const a = addBusinessDays(start, min);
    const b = addBusinessDays(start, max);
    const out = el.querySelector('[data-sa-range]');
    const lead = el.querySelector('[data-sa-lead]');
    if (out) out.textContent = `${fmt.format(a)} to ${fmt.format(b)}`;
    if (lead) lead.textContent = 'Arrives';
    const xmasEl = el.querySelector('[data-sa-xmas]');
    if (xmasEl && el.dataset.xmas === 'true') {
      const y = now.getFullYear();
      const target = new Date(y, 11, 23);
      let order = new Date(now);
      // latest working day whose latest delivery lands on or before Dec 23
      let probe = new Date(y, 11, 23);
      while (addBusinessDays(probe, max) > target) probe.setDate(probe.getDate() - 1);
      while (!isWorkday(probe)) probe.setDate(probe.getDate() - 1);
      if (now.getMonth() >= 9 && now <= probe) {
        xmasEl.hidden = false;
        xmasEl.textContent = `Order by ${fmt.format(probe)} for delivery before Christmas.`;
      }
    }
  });

  /* Multi-buy tiers: drive the quantity box and show tier totals */
  if (!customElements.get('sa-tiers')) {
    customElements.define('sa-tiers', class extends HTMLElement {
      connectedCallback() {
        const sid = this.dataset.section;
        this.qty = document.getElementById('Quantity-' + sid);
        this.radios = [...this.querySelectorAll('input[type="radio"]')];
        const money = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(n);
        const priceRoot = document.getElementById('price-' + sid);
        const unit = () => {
          if (!priceRoot) return 0;
          const el = priceRoot.querySelector('.price__sale:not([hidden]) .price-item--sale, .price-item--last, .price-item--regular');
          const n = el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) : 0;
          return isNaN(n) ? 0 : n;
        };
        const paint = () => {
          const u = unit();
          this.radios.forEach((r) => {
            const q = Number(r.value), off = Number(r.dataset.off) || 0;
            const box = r.closest('.sa-tier').querySelector('[data-sa-tier-price]');
            if (!box || !u) return;
            const total = u * q * (1 - off / 100);
            box.textContent = q === 1 ? money(u) : `${money(total)}`;
          });
        };
        paint();
        if (priceRoot) new MutationObserver(paint).observe(priceRoot, { childList: true, subtree: true, characterData: true });
        this.radios.forEach((r) => r.addEventListener('change', () => {
          if (!this.qty) return;
          this.qty.value = r.value;
          this.qty.dispatchEvent(new Event('change', { bubbles: true }));
        }));
        if (this.qty) this.qty.addEventListener('change', () => {
          const v = Number(this.qty.value) || 1;
          const pick = this.radios.slice().reverse().find((r) => v >= Number(r.value));
          if (pick && !pick.checked) pick.checked = true;
        });
      }
    });
  }

  /* Sticky add to cart mirrors the main product form */
  if (!customElements.get('sa-sticky-atc')) {
    customElements.define('sa-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        const mainBtn = document.querySelector('product-info .product-form__submit, .product-form__submit[name="add"]');
        const btn = this.querySelector('[data-sa-sticky-btn]');
        if (!mainBtn || !btn) return;
        btn.addEventListener('click', () => {
          mainBtn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          if (!mainBtn.disabled) mainBtn.click();
        });
        const sync = () => {
          btn.disabled = mainBtn.disabled;
          btn.textContent = mainBtn.disabled ? (mainBtn.textContent || '').trim() : btn.dataset.label || btn.textContent;
          const price = document.querySelector('product-info .price-item--last, product-info .price__regular .price-item--regular');
          const out = this.querySelector('[data-sa-sticky-price]');
          if (price && out) out.textContent = price.textContent.trim();
        };
        btn.dataset.label = btn.textContent.trim();
        new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, subtree: true });
        const io = new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', show);
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
          btn.tabIndex = show ? 0 : -1;
        });
        io.observe(mainBtn);
      }
    });
  }
})();


/* Cart add-on buttons: add to cart and refresh the drawer in place */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-sa-add]');
  if (!btn) return;
  e.preventDefault();
  btn.setAttribute('aria-busy', 'true');
  const drawer = document.querySelector('cart-drawer');
  const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
  try {
    const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.saAdd), quantity: 1 }], sections, sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (drawer && data.sections) { drawer.renderContents(data); }
    else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
  } catch (err) {
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
});
